// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="./adyen.d.ts" />

if (!globalThis.navigator) {
  globalThis.navigator = { appName: 'Browser' } as any;
}
if (!globalThis.window) {
  globalThis.window = null as any;
}

export { createEncryption, CSEInstance, CSEPayload } from 'adyen-cse-js/js/adyen.encrypt.nodom';
